import React, { useEffect, useState } from "react";
import FormButton from "../ui/button/FormButton";
import { useSelector } from "react-redux";
import { API } from "../../pages/backend";
import axios from "axios";
import { Box, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { MdErrorOutline } from "react-icons/md";
import { TbFaceIdError } from "react-icons/tb";



const TransactionCard = () => {

  const details = useSelector((state) => state?.transactionDetails?.data?.transactionDetails);

  const user = useSelector((state) => state.user.data.details);
  const token = useSelector((state) => state.user.data.token);
  // console.log(token);
  const [platformTransactionDetails, setPlatformTransactionDetails] = useState(
    []
  );
  // console.log(platformTransactionDetails);

  const getAllPlatformTransactions = async () => {
    try {
      const res = await axios.get(
        `${API}/transactions/all?payerId=${details?.payerId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if ((res.status = "success")) {
        // console.log(res);
        // console.log(res.data);

        // console.log(res?.data?.data?.details?.rows)
        setPlatformTransactionDetails(res?.data?.data?.details?.rows);
        // console.log(platformTransactionDetails);
      }
    } catch (error) {
      toast.error(
        "Cannot generate transaction cards at the moment. Try again later."
      );
      // console.log(error);
    }
  };

  useEffect(() => {
    getAllPlatformTransactions();
  }, []);

  return (
    <div>
      {platformTransactionDetails ? (

        platformTransactionDetails?.length === 0 ? <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', paddingTop: '50px', gap: '40px' }}>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
            <MdErrorOutline size={'25px'} />
            <Typography align="center" fontSize={'19px'} fontWeight={500} > You have not made a transaction via this platform yet. </Typography>
          </div>

          <Typography align="center" fontSize={'17px'} fontWeight={600} > Click on the User Details tab to generate an invoice. </Typography>

        </div> :


          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {platformTransactionDetails?.map((item, i) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  // padding: "70px 80px",
                  width: window.innerWidth >= 320 ? "150%" : "00%",
                  padding: window.innerWidth >= 320 ? "30px 85px" : "30px",
                }}
              >
                <div
                  style={{
                    border: "1px solid #34A56F",
                    borderRadius: "10px",
                    // width: window.innerWidth >= 320 ? "200%" : "00%",
                    height: "310px",
                    display: "flex",
                    flexDirection: "column",
                    padding:
                      window.innerWidth >= 320
                        ? "20px 20px 20px 20px"
                        : "200px, 200px",
                    gap: "25px",
                    backgroundColor: "#f2fcf8",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      fontSize: "18px",
                      fontWeight: "600",
                    }}
                  >
                    Bill Number: {item?.billNumber}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      fontSize: "18px",
                      fontWeight: "600",
                    }}
                  >
                    Payer Name: {item.fullName}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      fontSize: "18px",
                      fontWeight: "600",
                    }}
                  >
                    PayerId: {item?.payerId}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      fontSize: "18px",
                      fontWeight: "600",
                    }}
                  >
                    Amount Paid: {item?.amount}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      fontSize: "18px",
                      fontWeight: "600",
                    }}
                  >
                    Transaction Reference: {item?.trxRef}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      fontSize: "18px",
                      fontWeight: "600",
                    }}
                  >
                    {" "}
                    Email: {item?.email}
                  </div>

                  {/* <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }} >
                                <div style={{ display: 'flex', alignItems: 'flex-start', fontSize: '18px', fontWeight: '600', gap: '10px' }} >Payment Status: </div>
                                {item.status === 'Unpaid' ?
                                    <p style={{ padding: '5px 5px', backgroundColor: '#f94449', fontSize: '17px', color: '#ffffff', borderRadius: '4px' }}>{item.status}</p>
                                    : item.status === 'paid' ?
                                        <p style={{ padding: '5px 5px', backgroundColor: '#34a56f', fontSize: '17px', color: '#ffffff', borderRadius: '4px' }}>{item.status}</p>
                                        :
                                        item.status === 'part-payment' ?
                                            <p style={{ padding: '5px 5px', backgroundColor: '#34a56f', fontSize: '17px', color: '#ffffff', borderRadius: '4px' }}>{item.status}</p>
                                            : <p style={{ padding: '5px 5px', backgroundColor: '#34a56f', fontSize: '17px', color: '#ffffff', borderRadius: '4px' }}>{'Awaiting Confirmation'}</p>
                                }
                            </div> */}
                  {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                <FormButton width='medium' label={'Check Status'} />
                                <FormButton width='medium' label={'Generate Receipt'} />
                            </div> */}
                </div>
              </div>
            ))}
          </Box>
      ) : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '50px', gap:'5px' }}>
        <TbFaceIdError size={'25px'} />
        <Typography align="center" fontSize={'19px'} fontWeight={500} > Can't seem to get your transaction details. Can you try again later? </Typography>
      </div>
      }
    </div >
  );
};

export default TransactionCard;
